import React, { useState, useEffect, useCallback } from 'react';
import adminService from '../services/adminService';
import { toast } from 'react-toastify';

const AdminContentTab = () => {
  const [contentType, setContentType] = useState('faq');
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [editedContent, setEditedContent] = useState('');

  const contentTypes = [
    { id: 'faq', label: 'FAQs' },
    { id: 'guidelines', label: 'Guidelines' },
    { id: 'terms', label: 'Terms & Conditions' },
    { id: 'privacy', label: 'Privacy Policy' },
  ];

  const loadContent = useCallback(async () => {
    setLoading(true);
    try {
      const data = await adminService.getContent(contentType);
      setContent(data);
      setEditedContent(data.content);
    } catch (error) {
      toast.error('Failed to load content');
    } finally {
      setLoading(false);
    }
  }, [contentType]);

  useEffect(() => {
    loadContent();
  }, [contentType, loadContent]);



  const handleSave = useCallback(async () => {
    try {
      await adminService.updateContent(contentType, {
        content: editedContent,
      });
      toast.success('Content updated successfully');
      setEditing(false);
      loadContent();
    } catch (error) {
      toast.error('Failed to update content');
    }
  }, [contentType, editedContent, loadContent]);

  if (loading) {
    return <div className="flex justify-center p-4">Loading...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex space-x-4 mb-4">
        {contentTypes.map((type) => (
          <button
            key={type.id}
            className={`px-4 py-2 rounded ${
              contentType === type.id
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700'
            }`}
            onClick={() => {
              setContentType(type.id);
              setEditing(false);
            }}
          >
            {type.label}
          </button>
        ))}
      </div>

      <div className="bg-white p-4 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">
            {contentTypes.find((t) => t.id === contentType)?.label}
          </h2>
          {!editing ? (
            <button
              onClick={() => setEditing(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Edit
            </button>
          ) : (
            <div className="space-x-2">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Save
              </button>
              <button
                onClick={() => {
                  setEditing(false);
                  setEditedContent(content.content);
                }}
                className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
              >
                Cancel
              </button>
            </div>
          )}
        </div>

        {editing ? (
          <textarea
            value={editedContent}
            onChange={(e) => setEditedContent(e.target.value)}
            className="w-full h-96 p-2 border rounded"
          />
        ) : (
          <div className="prose max-w-none">
            {content?.content ? (
              <div dangerouslySetInnerHTML={{ __html: content.content }} />
            ) : (
              <p className="text-gray-500">No content available</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContentTab;
